import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, PawPrint } from "lucide-react";

export const FinalCTA = () => {
  return (
    <section className="px-5 sm:px-8 lg:px-10 pb-20" data-testid="final-cta-section">
      <motion.div
        initial={{ opacity: 0, y: 22 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7 }}
        className="relative overflow-hidden rounded-[40px] bg-[#1E5F6E] text-white max-w-7xl mx-auto px-6 md:px-14 py-20 md:py-28 text-center"
      >
        {/* Decorative grain + shapes */}
        <div className="absolute inset-0 grain opacity-60 pointer-events-none" />
        <div className="absolute -left-16 top-1/2 -translate-y-1/2 h-72 w-72 rounded-full bg-[#88A096]/25" aria-hidden />
        <div className="absolute -right-12 -top-10 h-60 w-60 rounded-full bg-[#E8A87C]/20" aria-hidden />

        <div className="relative max-w-3xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur px-4 py-1.5 text-xs font-bold uppercase tracking-widest border border-white/15">
            <PawPrint className="h-3.5 w-3.5" />
            Estamos prontos a ajudar
          </span>
          <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-[52px] font-extrabold leading-[1.1] tracking-tight">
            Pronto para cuidar do seu <span className="text-[#E8A87C]">companheiro?</span>
          </h2>
          <p className="mt-5 text-base md:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
            Marque a sua consulta em menos de um minuto e escolha a clínica
            mais próxima de si.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/marcar-consulta"
              data-testid="final-cta-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#E8A87C] px-7 py-4 text-base font-bold text-[#1A1A1A] shadow-[0_10px_25px_-10px_rgba(232,168,124,0.7)] hover:bg-[#D99A6E] hover:-translate-y-0.5 transition-all"
            >
              Marcar consulta agora
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/contactos"
              data-testid="final-cta-secondary"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-white/10 backdrop-blur border-2 border-white/20 px-7 py-4 text-base font-bold text-white hover:bg-white/15 transition-colors"
            >
              Falar connosco
            </Link>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default FinalCTA;
